export const STATUS_IMAGE_BASE = 'https://cdn.printos.com/images/status/';
export const STATE = Object.freeze({
  UNKNOWN: {
    rank: Infinity,
    color: '#E5E8E8',           // Matches the $hp-disabled-gray
    staleColor: '#E5E8E8',      // Matches the $hp-disabled-gray
    colorSilent: 'transparent',
    status: 'unknown',
    class: 'gz-status-neutral',
  },
  ERROR: {
    rank: 0,
    color: '#F04B37',           // Matches the $hp-status-red
    staleColor: '#E5E8E8',       // Matches the $hp-disabled-gray
    status: 'error',
    class: 'gz-status-error',
  },
  WARN: {
    rank: 1,
    color: '#F0AA3C',           // Matches the $hp-status-yellow
    staleColor: '#E5E8E8',       // Matches the $hp-disabled-gray
    status: 'warning',
    class: 'gz-status-warn',
  },
  OFF: {
    rank: 2,
    color: '#F0AA3C',           // Matches the $hp-status-yellow
    staleColor: '#E5E8E8',       // Matches the $hp-disabled-gray
    //colorSilent: "transparent",  // Use this color if you don't want to call attention to this state
    status: 'off',
    class: 'gz-status-neutral',
  },
  OK: {
    rank: 3,
    color: '#509137',           // Matches the $hp-status-green
    staleColor: '#E5E8E8',      // Matches the $hp-disabled-gray
    colorSilent: "transparent",  // Use this color if you don't want to call attention to this state
    status: 'ok',
    class: 'gz-status-ok',
  }
});


export const name = '$gzDeviceStatus';
/**
 * @ngdoc service
 * @name gazelle.components.card.service:$gzDeviceStatus
 *
 * @description
 * The $gzDeviceStatus service provides a mechanism to get individual and combined device status information.
 */
export default function $gzDeviceStatus($log, $filter) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let service = {
    getDeviceStatus: getDeviceStatus,
    getInkState: getInkState,
    getOverallState: getOverallState,
    getOverallStateOfMultipleDevices: getOverallStateOfMultipleDevices
  };
  return service;

  //
  // Public functions
  //

  /**
   * @ngdoc function
   * @name getDeviceStatus
   * @methodOf gazelle.components.card.service:$gzDeviceStatus
   * @description Get the status information for a device
   * @param {Object} element - A device object
   * @param {Object} [options] - Optional. Options.
   * @returns {Object} A status object, i.e.: {text: "someString", image: "imagePath", state: {rank: 0, color: #F04B37}}
  */
  function getDeviceStatus(device, options) {
    let deviceSpecificStatusKey = null;
    if (device && device.data && device.data.miscInfo && device.data.miscInfo.deviceSpecificStatusKey) {
      deviceSpecificStatusKey = device.data.miscInfo.deviceSpecificStatusKey;
    }

    let status = {
      text: (deviceSpecificStatusKey) ? $filter('L10N')(deviceSpecificStatusKey) : $filter('L10N')('devices.devices.Status_Unknown'),
      image: STATUS_IMAGE_BASE + 'unknown.svg',
      state: STATE.UNKNOWN
    };

    try {
      switch(_.get(device, 'data.deviceStatus')) {
        case 'DS_PRINTING':
          status = {
            text: (deviceSpecificStatusKey) ? $filter('L10N')(deviceSpecificStatusKey) :
                  (device.type === "IndigoDFE" || device.type === "ProductionCenter") ? $filter('L10N')('devices.devices.DFE_Status_Printing') :
                  (device.type === "IndigoPress") ? $filter('L10N')('devices.devices.Indigo_Press_Status_printing') :
                  $filter('L10N')('devices.devices.Status_Printing'),
            image: STATUS_IMAGE_BASE + 'printing.svg',
            state: STATE.OK
          };
          break;
        case 'DS_RIPPING':
          status = {
            text: (deviceSpecificStatusKey) ? $filter('L10N')(deviceSpecificStatusKey) :
                  (device.type === "IndigoDFE" || device.type === "ProductionCenter") ? $filter('L10N')('devices.devices.DFE_Status_Ripping') :
                  (device.type === "IndigoPress") ? $filter('L10N')('devices.devices.Indigo_Press_Status_printing') :
                  $filter('L10N')('devices.devices.Status_Processing'),
            image: STATUS_IMAGE_BASE + 'processing.svg',
            state: STATE.OK
          };
          break;
        case 'DS_ON':
          status = {
            text: (deviceSpecificStatusKey) ? $filter('L10N')(deviceSpecificStatusKey) :
                  (device.type === "IndigoDFE" || device.type === "ProductionCenter") ? $filter('L10N')('devices.devices.DFE_Status_Ready') :
                  (device.type === "IndigoPress") ? $filter('L10N')('devices.devices.Indigo_Press_Status_readytoprint') :
                  $filter('L10N')('devices.devices.Status_PoweredOnIdle'),
            image: STATUS_IMAGE_BASE + 'ok.svg',
            state: STATE.OK
          };
          break;
        case 'DS_STANDBY':
          status = {
            text: (deviceSpecificStatusKey) ? $filter('L10N')(deviceSpecificStatusKey) :
                  (device.type === "IndigoDFE" || device.type === "ProductionCenter") ? $filter('L10N')('devices.devices.DFE_Status_Paused') :
                  (device.type === "IndigoPress") ? $filter('L10N')('devices.devices.Indigo_Press_Status_up') :
                  $filter('L10N')('devices.devices.Status_Standby'),
            image: STATUS_IMAGE_BASE + 'ok.svg',
            state: STATE.OK
          };
          break;
        case 'DS_OFF':
          status = {
            text: (deviceSpecificStatusKey) ? $filter('L10N')(deviceSpecificStatusKey) :
                  (device.type === "IndigoDFE" || device.type === "ProductionCenter") ? $filter('L10N')('devices.devices.DFE_Status_Offline') :
                  (device.type === "IndigoPress") ? $filter('L10N')('devices.devices.Indigo_Press_Status_down') :
                  $filter('L10N')('devices.devices.Status_PoweredOff'),
            image: STATUS_IMAGE_BASE + 'unknown.svg',
            state: STATE.OFF
          };
          break;
        case 'DS_WARNING':
          status = {
            text: (deviceSpecificStatusKey) ? $filter('L10N')(deviceSpecificStatusKey) :
                  (device.type === "IndigoDFE" || device.type === "ProductionCenter") ? $filter('L10N')('devices.devices.DFE_Status_Warning') :
                  (device.type === "IndigoPress") ? $filter('L10N')('devices.devices.Indigo_Press_Status_warning') :
                  $filter('L10N')('devices.devices.Status_Warning'),
            image: STATUS_IMAGE_BASE + 'warning.svg',
            state: STATE.WARN
          };
          break;
        case 'DS_ERROR':
          status = {
            text: (deviceSpecificStatusKey) ? $filter('L10N')(deviceSpecificStatusKey) :
                  (device.type === "IndigoDFE" || device.type === "ProductionCenter") ? $filter('L10N')('devices.devices.DFE_Status_Problem') :
                  (device.type === "IndigoPress") ? $filter('L10N')('devices.devices.Indigo_Press_Status_error') :
                  $filter('L10N')('devices.devices.Status_Error'),
            image: STATUS_IMAGE_BASE + 'error.svg',
            state: STATE.ERROR
          };
          break;
        default:
          break;
      }

      status.isStale = false;
      // Determine if the status is stale since some devices want to display the Disconnected status if the status is stale
      // Currently, "some devices" are: Indigo Press, 3D, Production Center
      if (device.type === "IndigoPress" || device.type === "ThreeDPrinter" || device.type === "ThreeDController" || device.type === "ProductionCenter") {
        let msBeforeStale = 10 * 60 * 1000;
        if (options && options.msBeforeStale) {
          msBeforeStale = options.msBeforeStale;
        }
        if (device && device.data && device.data.lastUpdate && msBeforeStale > 0) {
          let msSinceUpdate = Date.now() - new Date(device.data.lastUpdate).getTime();
          if (msSinceUpdate > msBeforeStale) {
            status.isStale = true;
            status.text = $filter('L10N')('devices.devices.Status_Disconnected');
            status.image = STATUS_IMAGE_BASE + 'unknown.svg';
            status.state = STATE.UNKNOWN;
          }
        }
      }

    } catch (e) {
    }

    return status;
  }

  /**
   * @ngdoc function
   * @name getInkState
   * @methodOf gazelle.components.card.service:$gzDeviceStatus
   * @description Get the combined ink state information for a device
   * @param {Object} element - A device object
   * @param {Object} inkThresholds - Ink level thresholds, i.e: {error: 10, warn: 30}
   * @returns {Object} A STATE object, i.e.: {rank: 0, color: #F04B37}
   */
  function getInkState(device, inkThresholds) {
    let state = STATE.UNKNOWN;
    if ((inkThresholds !== undefined) && (inkThresholds.error !== undefined) && (inkThresholds.warn !== undefined) ) {
      try {
        let inkLevels = device.inkLevels;
        if(!inkLevels || (inkLevels.length < 1)) {
          state = STATE.UNKNOWN;
        }
        else {
          let minInk = _.minBy(inkLevels, 'value');
          let minInkValue = parseInt(minInk.value);
          if(minInk.value >= inkThresholds.warn) {
            state = STATE.OK;
          }
          else if(minInk.value >= inkThresholds.error) {
            state = STATE.WARN;
          }
          else if(minInk.value >= 0) {
            state = STATE.ERROR;
          }
        }
      }
      catch(e) {
        state = STATE.UNKNOWN;
      }
    }

    return state;
  }

  /**
   * @ngdoc function
   * @name getOverallState
   * @methodOf gazelle.components.card.service:$gzDeviceStatus
   * @description Get the overall state of the device, taking into account device status and ink state
   * @param {Object} element - A device object
   * @param {Object} [thresholds] - Optional. Thresholds, i.e: {ink: {error: 10, warn: 30}}. If 'ink' threshold
   * is present then the specific type of levels will be taken into consideration when determining the overall state.
   * If, for example, you don't want ink to be included in the status determination then don't include any ink element.
   * @returns {Object} A STATE object, i.e.: {rank: 0, color: #F04B37}
   */
  function getOverallState(device, thresholds) {
    let state = STATE.UNKNOWN;
    try {
      let states = [];
      states.push(getDeviceStatus(device, {}).state);
      if (thresholds !== undefined) {
        // Check to see if we are supposed to include ink status
        if ((thresholds.ink !== undefined) && (thresholds.ink.error !== undefined) && (thresholds.ink.warn !== undefined)) {
          states.push(getInkState(device, thresholds.ink));
        }
      }
      state = _.minBy(states, 'rank');
    }
    catch(e) {
      state = STATE.UNKNOWN;
    }
    return state;
  }

  /**
   * @ngdoc function
   * @name getOverallStateOfMultipleDevices
   * @methodOf gazelle.components.card.service:$gzDeviceStatus
   * @description Get the overall state of the device, taking into account device status and ink state
   * @param {Array} element - An array of device objects
   * @param {Object} [thresholds] - Optional. Thresholds, i.e: {ink: {error: 10, warn: 30}}. If 'ink' threshold
   * is present then the specific type of levels will be taken into consideration when determining the overall state.
   * If, for example, you don't want ink to be included in the status determination then don't include any ink element.
   * @returns {Object} A STATE object, i.e.: {rank: 0, color: #F04B37}
   */
  function getOverallStateOfMultipleDevices(devices, thresholds) {
    let state = STATE.UNKNOWN;
    try {
      let states = [];
      for(let i = 0; i < devices.length; i++) {
        states.push(getDeviceStatus(devices[i], {}).state);
        if (thresholds !== undefined) {
          // Check to see if we are supposed to include ink status
          if ((thresholds.ink !== undefined) && (thresholds.ink.error !== undefined) && (thresholds.ink.warn !== undefined)) {
            states.push(getInkState(devices[i], thresholds.ink));
          }
        }
      }
      state = _.minBy(states, 'rank');
    }
    catch(e) {
      state = STATE.UNKNOWN;
    }
    return state;
  }
}
